export default {
  "content": "<path d=\"M7.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18.5 19a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM3 3a1 1 0 01.948.684L4.721 6H9v2H5.344l2.4 8h10.512l2.786-9.287 1.916.574-3 10A1 1 0 0119 18H7a1 1 0 01-.958-.713l-3-10L2.279 5H.5V3H3z\" fill=\"#7B61FF\"/><path d=\"M21.759 3.65l-6 7a1 1 0 01-1.518 0l-3-3.5 1.518-1.3L15 8.464l5.241-6.114 1.518 1.3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};